import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  Card,
  CardContent,
  // CardTitle,
  // CardDescription,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { User } from "lucide-react";
import { useChats } from "@/providers/chat-provider";
import { useTranslation } from "@/providers/language-provider";
import { useMemo } from "react";
import { formatRelativeTime } from "@/lib/date-tools";

export function FriendItem({
  user,
  onClick,
}: {
  user: any;
  onClick: () => void;
}) {
  const { t } = useTranslation();
  const { friends } = useChats();
  const me = useMemo(
    () => friends?.find((friend: any) => friend._id === user._id),
    [friends, user._id],
  );

  return (
    <Card>
      <CardHeader className="p-2">
        <div className="flex justify-between">
          <User className="h-4 w-4" />
          {/* 상태 표시 Dot */}
          <span
            className={`h-3 w-3 rounded-full border-2 border-background ${
              me?.isOnline ? "bg-green-500" : "bg-slate-400"
            }`}
            aria-hidden="true"
          />

          {/* 스크린 리더용 텍스트 (접근성) */}
          <span className="sr-only">
            {me?.isOnline ? "온라인" : "오프라인"}
          </span>
        </div>
      </CardHeader>
      <CardContent className="px-4 py-2">
        <div className="flex cursor-pointer" onClick={onClick}>
          <Avatar className="size-[64px]">
            <AvatarImage
              src={user.picture ?? "/images/anonymous-icon.jpg"}
              alt={user.picture ?? "Profile Image"}
            />
            <AvatarFallback>N/A</AvatarFallback>
          </Avatar>
          <div className="flex flex-col text-left text-sm leading-tight p-2">
            <span className="truncate font-semibold">
              {user.name || "Unknown"}
            </span>
            <span className="truncate text-xs text-muted-foreground">
              {user.email}
            </span>
          </div>
        </div>
      </CardContent>
      <CardFooter
        className={`flex justify-end p-2 text-xs ${
          me?.isOnline ? "text-green-500" : "text-muted-foreground"
        }`}
      >
        {me?.isOnline
          ? t("Online")
          : me?.lastSeen
            ? `${t("LastSeen")}: ${formatRelativeTime(me.lastSeen)}`
            : t("Offline")}
      </CardFooter>
    </Card>
  );
}
